import { useState } from "react";
import { useNavigate } from "react-router-dom";
import KomentarModal from "../../../../evidencija/components/Supervizije/Accordions/KomentarModal/KomentarModal";
import "./OdobrenjeTable.css";

function RenderTableData({ data = [] }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [polaznik, setPolaznik] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  return (
    <>
      {data.map((item, index) => (
        <tr key={index} style={{ cursor: "pointer" }}>
          <td
            onClick={() =>
              navigate(`/evidencijaVoditeljPolaznik/${item?.userId}`)
            }
          >
            <div className="table-odobrenje-row" style={{ color: "#2E3646" }}>
              <img
                alt=""
                src={item.imageUrl}
                className="table-odobrenje-aplikacija-avatar"
              />
              {item.firstName} {item.lastName}
            </div>
          </td>
          <td>
            <span
              onClick={() =>
                navigate(
                  `/dokumenti/aplikacije-za-upis/anketa/${item.applicationId}`
                )
              }
              className="table-odobrenje-aplikacija-link"
            >
              Link na anketu
            </span>
          </td>
          <td style={{ maxWidth: 400 }}>
            <div>
              {item?.isMentorAccepted === true
                ? "Odobreno"
                : item?.isMentorAccepted === false
                  ? "Odbijeno"
                  : "Nema evaluacije"}
            </div>
          </td>
          <td>
            <p>
              {item?.mentorReview ? (
                <>
                  <span
                    style={{
                      cursor:
                        item?.mentorReview?.length > 100
                          ? "pointer"
                          : "not-allowed",
                      textDecoration:
                        item?.mentorReview?.length > 100 ? "underline" : "",
                      pointerEvents:
                        item?.mentorReview?.length < 100 ? "none" : undefined,
                    }}
                    className="table-odobrenje-comment"
                    onClick={() => {
                      setPolaznik(`${item?.firstName} ${item?.lastName}`);
                      setSelectedText(item?.mentorReview);
                      setReadOnly(true);
                      setShowModal(true);
                    }}
                  >
                    {item?.mentorReview}
                  </span>
                </>
              ) : (
                <span>------</span>
              )}
            </p>
          </td>
        </tr>
      ))}
      {showModal && (
        <KomentarModal
          onClose={() => setShowModal(false)}
          commentText={selectedText}
          readOnly={readOnly}
          isApplicationReferada
          polaznik={polaznik}
        />
      )}
    </>
  );
}

export default RenderTableData;
